import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Paper } from "@mui/material";
import { Block as BlockIcon } from "@mui/icons-material";

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate("/dashboard");
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="background.default"
      p={3}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          width: "100%",
          textAlign: "center",
        }}
      >
        <BlockIcon
          sx={{
            fontSize: 80,
            color: "error.main",
            mb: 2,
          }}
        />
        
        <Typography variant="h3" component="h1" gutterBottom>
          403
        </Typography>
        
        <Typography variant="h5" gutterBottom>
          Åtkomst nekad
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          Du har inte behörighet att visa denna sida. Kontakta din administratör om du
          anser att du borde ha tillgång till denna resurs.
        </Typography>

        <Box sx={{ mt: 4, display: "flex", gap: 2, justifyContent: "center" }}>
          <Button
            variant="outlined"
            onClick={handleGoBack}
          >
            Gå tillbaka
          </Button>
          <Button
            variant="contained"
            onClick={handleGoHome}
          >
            Till startsidan
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default UnauthorizedPage;